export default "__VITE_ASSET__6c34cf95__"